
export enum RouteName {
    VideosRoute = 'videos',
    CategoryRoute = 'category',
    PlayerRoute = 'player',
    VideoRoute = 'video',
}
